import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import API from '../../api';

export default function AdminDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [univNom, setUnivNom] = useState('');

  useEffect(() => {
    API.get('stats/').then((res) => setStats(res.data)).catch(() => {});
    if (user?.universite) {
      API.get(`universites/${user.universite}/`).then((r) => setUnivNom(r.data.nom || r.data.sigle)).catch(() => {});
    }
  }, [user]);

  if (!stats) return <div className="loading-screen"><div className="spinner" /><p>Chargement…</p></div>;

  return (
    <div>
      <div className="page-header">
        <h2>Dashboard Administrateur</h2>
        {univNom && <p>{univNom}</p>}
      </div>
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon blue"><i className="bi bi-building" /></div>
          <div className="stat-info"><h3>{stats.universites}</h3><p>Universités</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon purple"><i className="bi bi-bank" /></div>
          <div className="stat-info"><h3>{stats.facultes}</h3><p>Facultés</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon green"><i className="bi bi-mortarboard" /></div>
          <div className="stat-info"><h3>{stats.promotions}</h3><p>Promotions</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon orange"><i className="bi bi-person-workspace" /></div>
          <div className="stat-info"><h3>{stats.enseignants}</h3><p>Enseignants</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon blue"><i className="bi bi-people" /></div>
          <div className="stat-info"><h3>{stats.etudiants}</h3><p>Étudiants</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon purple"><i className="bi bi-book" /></div>
          <div className="stat-info"><h3>{stats.cours}</h3><p>Cours</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon red"><i className="bi bi-clipboard-check" /></div>
          <div className="stat-info"><h3>{stats.evaluations}</h3><p>Évaluations</p></div>
        </div>
      </div>
    </div>
  );
}
